import { RingLoader } from "react-spinners";
import { ClockLoader } from "react-spinners";
import PropTypes from 'prop-types';
import SoftBox from "components/SoftBox";
import { Grid } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftTypography from "components/SoftTypography";

function LoadingSpinnerNewTranscript({loading, patientName, selectedPatient}) {

  const nameToDisplay = patientName || selectedPatient;
  
  return (
    <SoftBox py={5}>
      <Grid container spacing={3} justifyContent="center" alignItems="center" direction="column">
            <Grid item xs={12} lg={11}>
                {loading && (
                    <SoftBox mb={1}>
                        <ClockLoader color="#344767" speedMultiplier={0.7} size={80} />
                    </SoftBox>
                )}
            </Grid>
            <Grid item xs={12} lg={11}>
                {loading && (

                  <SoftBox px={15}>  
                    <SoftBadge
                        variant="contained"
                        color="secondary"
                        size="sm"
                        badgeContent={
                            <SoftTypography px={2} color="button" variant="h6">
                                Updates to the transcript for {nameToDisplay} are being processed.<br></br> Please wait while the new data is being generated based on the revised transcript.
                            </SoftTypography>
                        }
                        circular
                        container
                    />
                  </SoftBox>
                    
                )}
            </Grid>
            {/*<Grid item xs={12} lg={11}>
                {loading && (
                    <SoftTypography variant="body2" color="text" >
                        <strong>Note:</strong> Feel free to start with a new recording/client while we process {nameToDisplay} details in the background.
                    </SoftTypography>
                )}
                </Grid>*/}
        </Grid>
    </SoftBox>

  );
}

LoadingSpinnerNewTranscript.propTypes = {
  loading: PropTypes.bool.isRequired,
  patientName: PropTypes.string,
  selectedPatient: PropTypes.string,
};


export default LoadingSpinnerNewTranscript;
